export default function initScrollProgressBar() {
    const $progressbar = document.querySelectorAll<HTMLElement>('.js-reading-progress-bar');

    $progressbar.forEach($bar => {
        new ScrollProgressBar($bar);
    });
}

/**
* @param {HTMLElement} $el
*/
class ScrollProgressBar {
    $el: HTMLElement | null;
    $footer: HTMLElement | null;
    $lastActus: HTMLElement | null;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$footer = document.querySelector('.main-footer');
        this.$lastActus = document.querySelector('.block-last-actu');

        this.init();
    }

    /**
     * Initialise la progressbar
     *
     * @return {void}
     */
    init() {
        let offsetBottom = 0;
        // modifie l'offset bottom si il y a le footer et le block maillage actu
        offsetBottom = this.$footer ? offsetBottom + this.$footer.offsetHeight : offsetBottom;
        offsetBottom = this.$lastActus ? offsetBottom + this.$lastActus.offsetHeight : offsetBottom;

        const progressBar = () => {
            // d'abord on prend la position du scroll du user
            const scrolledFromTop = document.documentElement.scrollTop || document.documentElement.scrollTop;
            // On défini un ratio qui prend en compte la hauteur du scroll mais aussi la taille de la fenetre
            const windowHeight = document.documentElement.scrollHeight - (document.documentElement.clientHeight);
            // On met ce ratio sous forme de pourcentage
            let progress = (scrolledFromTop / (windowHeight - offsetBottom)) * 100;
            // et on injecte ce pourcentage dans un élément html
            if (progress < 0) {
                progress = 0;
            }
            if (progress >= 100) {
                progress = 100;
            }
            if (this.$el) {
                this.$el.style.width = progress + '%';
            }
        };

        window.onscroll = () => {
            if (this.$el) {
                progressBar();
            }
        };
    }
}
